import type { ConversationListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const getConversationName = ({
	title,
	participant,
	isGroup,
}: Pick<
	ConversationListItemResponseDTO,
	"title" | "participant" | "isGroup"
>): string => (isGroup ? title || participant.name : participant.name || title);
